import React, { useEffect, useState } from "react";
import { Dropdown, Avatar, Space } from "antd";
import { Breadcrumb, Layout, Menu, theme, message, Modal } from "antd";
import {
  DesktopOutlined,
  FileOutlined,
  PieChartOutlined,
  TeamOutlined,
  UserOutlined,
  LogoutOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import { MdOutlineSell } from "react-icons/md";
import CustomModal from "./customModal";
import CustomForm from "./customForm";
import merchedese from "../assets/images/merchedes.svg";
import volkswagen from "../assets/images/volkswagen.svg";
import ferrari from "../assets/images/ferrari.svg";
import mazda from "../assets/images/mazda.svg";
import mitsubishi from "../assets/images/mitsubishi.svg";
import lamborghini from "../assets/images/lamborghini.svg";
import tesla from "../assets/images/tesla.svg";
import toyota from "../assets/images/toyota.svg";
import EastIcon from "@mui/icons-material/East";
import { LiaCarSideSolid } from "react-icons/lia";
import { FaRegCircleUser } from "react-icons/fa6";
import { HiOutlineUserCircle } from "react-icons/hi2";
import CustomButton from "./customButton";
import { customWhite, green } from "../constants/colors";
import { Padding } from "@mui/icons-material";
import { Button } from "antd";
import SignUpForm from "./signUpForm";
import LoginForm from "./loginForm";
import axios from "axios";
import { baseUrl } from "../utills";
import Header from "../container/carDetails/header";
import logo from "../assets/images/car-deal-center-logo.png";
import logoBlack from "../assets/images/MSM MOTOR LOGO.png";
import CustomSearch from "./customSearch";
import { IoMdSearch } from "react-icons/io";
import { MdSell } from "react-icons/md";
import { HiMenuAlt1 } from "react-icons/hi";
import { IoGitCompareSharp } from "react-icons/io5";
import { FcAbout } from "react-icons/fc";
import CustomDropdown from "./customDropDown";
import SellItForMeForm from "./sellBikeForm";
import SellBikeForm from "./sellBikeForm";
import { IoCarSportOutline } from "react-icons/io5";
import { TbMotorbike } from "react-icons/tb";
import { useGeneralInfo } from "../context/generalContext";

export default function CustomMenu({
  admin,
  carDetail,
  landing,
  isScrolled,
  toggleMenu,
}) {
  const token = localStorage.getItem("access_token");
  const [generalInfo, setGeneralInfo] = useGeneralInfo();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [anchorE3, setAnchorE3] = useState(null);

  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [openModal4, setOpenModal4] = useState(false);

  const login_data = JSON.parse(localStorage.getItem("login_data"));
  const [carBrands, setCarBrands] = useState();
  const [carModels, setCarModels] = useState();
  const [cities, setCities] = useState([]);
  const [province, setProvince] = useState([]);
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const user_id = localStorage.getItem("user_id");

  const userData = JSON.parse(localStorage.getItem("user"));
console.log("User Data:", userData);

  const pages = [
    { name: "Used Car", category_id: "1" },

    {
      name: "New Car",
      category_id: "2",
    },
    { name: "Bikes" },
    // { name: "More" },
    { name: "Contact Us" },
    { name: admin ? "Users" : "" },
    // { name: "Offer" },
  ];
  const pages2 = [
    { name: "About Us", path: "about", icon: <FcAbout /> },
    {
      name: "Find Auto Parts",
      path: "auto-parts",
      icon: <IoMdSearch style={{ fontSize: "18px" }} />,
    },
    { name: "Sell Car Parts", path: "sell-car-parts", icon: <MdSell /> },
    { name: "Compare Cars", path: "compare", icon: <IoGitCompareSharp /> },
  ];
  const bikes = [
    { name: "Used Bikes", path: "used-bikes", icon: <TbMotorbike style={{ fontSize: "22px" }}/> },
    {
      name: "New Bikes",
      path: "new-bikes",
      icon: <TbMotorbike style={{ fontSize: "22px" }} />,
    },
  ];
  const fetchCarBrands = async () => {
    try {
      const res = await axios.get(baseUrl + "get_car_makers/");
      if (res.status === 200) {
        setCarBrands(res?.data?.car_makers);
        setGeneralInfo((prevInfo) => ({
          ...prevInfo,
          makes: res?.data?.car_makers,
        }));
      }
      console.log("car brands", res);
    } catch (error) {
      console.error("error:", error);
    }
  };
  const fetchCities = async () => {
    try {
      const res = await axios.get(baseUrl + "cities/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        setCities(res?.data);
        setGeneralInfo((prevInfo) => ({
          ...prevInfo,
          cities: res?.data,
        }));
      }
      console.log("citiess", res);
    } catch (error) {
      console.error("error:", error);
    }
  };
  const fetchProvince = async () => {
    try {
      const res = await axios.get(baseUrl + "province/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        setProvince(res?.data);
      }
      console.log("Province....:", res);
    } catch (error) {
      console.error("error:", error);
    }
  };

  const fetchCarModels = async () => {
    try {
      const res = await axios.get(baseUrl + "car_models/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        // setCarModels(res?.data?.car_models);
        setCarModels(res?.data?.car_models);
      }
      // console.log("popular car models:", res);
    } catch (error) {
      console.error("error:", error);
    }
  };

  useEffect(() => {
    fetchCarBrands();
    fetchCities();
    fetchProvince();
    fetchCarModels();
  }, [token]);
  const handleMenuOpen = (event, page) => {
    if (page.name == "New Car" || page.name == "Used Car") {
      setAnchorEl(page.name);
    } else if (page.name == "More") {
      setAnchorE2(page.name);
    } else if (page.name == "Bikes") {
      setAnchorE3(page.name);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setAnchorE2(null);
    setAnchorE3(null);
  };
  const logOut = async () => {
    try {
      const res = await axios.post(
        baseUrl + "logout",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 200) {
        localStorage.clear("");
        console.log("logout res...", res);

        messageApi.open({
          type: "success",
          content: res?.data?.detail,
        });
        navigate("/login");
      }
    } catch (error) {
      // localStorage.clear("");
    }
  };
  const items = [
    {
      label: (
        <div
          style={{
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <UserOutlined />
          <p
            style={{ fontWeight: 500 }}
            onClick={() => navigate("/layout/ads")}
          >
            My Ads
          </p>
        </div>
      ),
      key: "1",
    },
    {
      label: (
        <div
          style={{
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
          onClick={() => navigate("/my-profile/edit")}
        >
          <UserOutlined />
          <p style={{ fontWeight: 500 }}>My Profile</p>
        </div>
      ),
      key: "2",
    },
    {
      type: "divider",
    },
    {
      label: (
        <div
          onClick={logOut}
          style={{
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: "10px",
            borderRadius: "4px",
            width: "200px",
            marginBottom: "10px",
          }}
        >
          <LogoutOutlined />
          <p>Logout</p>
        </div>
      ),
      key: "3",
    },
  ];
  const items2 = [
    {
      label: (
        <div
          style={{
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <IoCarSportOutline style={{ fontSize: "18px", color: green }} />
          <p
            style={{ fontWeight: 500 }}
            onClick={() => {
              if (token && user_id) {
                setOpenModal(true);
              } else {
                navigate("/login");
              }
            }}
          >
            Post a Car
          </p>
        </div>
      ),
      key: "1",
    },
    {
      label: (
        <div
          style={{
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <TbMotorbike style={{ fontSize: "20px", color: green }} />
          <p
            style={{ fontWeight: 500 }}
            onClick={() => {
              if (token && user_id) {
                setOpenModal4(true);
              } else {
                navigate("/login");
              }
            }}
          >
            Post a Bike
          </p>
        </div>
      ),
      key: "2",
    },
  ];

  const modifiedCities = cities?.map((item) => {
    return {
      label: item?.name,
      value: item?.id,
    };
  });
  const modifiedProvince = province?.map((item) => {
    return {
      label: item?.name,
      value: item?.id,
    };
  });

  return (
    <>
      {contextHolder}
      <CustomModal
        title="Sell Your Car"
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <CustomForm
          setOpenModal={setOpenModal}
          cities={modifiedCities}
          // province={modifiedCities}
          province={modifiedProvince}
        />
      </CustomModal>
      <CustomModal
        title="Sell Your Bike"
        openModal={openModal4}
        setOpenModal={setOpenModal4}
      >
        <SellBikeForm
          setOpenModal={setOpenModal4}
          cities={modifiedCities}
          province={modifiedProvince}
        />
      </CustomModal>
      <CustomModal
        signup="true"
        openModal={openModal2}
        setOpenModal={setOpenModal2}
      >
        <SignUpForm
          setOpenModal2={setOpenModal2}
          setOpenModal3={setOpenModal3}
        />
      </CustomModal>
      <CustomModal
        login="true"
        openModal={openModal3}
        setOpenModal={setOpenModal3}
      >
        <LoginForm
          setOpenModal3={setOpenModal3}
          setOpenModal2={setOpenModal2}
        />
      </CustomModal>
      <div
        className={`flex justify-between items-center px-3 lg:px-10 py-[5px] ${
          landing === "true"
            ? "border-b border-[rgba(255,255,255,0.15)]"
            : "border-b border-gray-300"
        }
        h-[67px]
        `}
      >
        <img
          onClick={() => navigate("/layout")}
          // className={`w-[80px] h-[50px] md:w-[105px] md:h-[50px] flex md:flex cursor-pointer
          // }`}
          className={`w-[170px] flex md:flex cursor-pointer
            }`}
          // src={landing === "true" ? logo : logoBlack}
          src={logo}

          alt="logo"
        />

        {/* <div
          style={{
            justifyContent: "space-between",
          }}
          className="flex items-center lg:hidden"
        > */}
        {!admin ? (
          <Header
            landing={landing}
            pages={pages}
            carBrands={carBrands}
            cities={cities}
            carModels={carModels}
            setOpenModal={setOpenModal}
            setOpenModal3={setOpenModal3}
            setOpenModal4={setOpenModal4}
            isScrolled={isScrolled}
            bikes={bikes}
          />
        ) : (
          <button
            type="button"
            className={`-m-2.5 inline-flex lg:hidden items-center justify-center rounded-md p-2.5 ${
              landing ? "text-[white]" : "text-gray"
            }`}
            onClick={toggleMenu}
          >
            <span className="sr-only">Open main menu</span>
            <HiMenuAlt1 style={{ fontSize: "20px", marginRight: "5px" }} />{" "}
            <span className="font-[500]">MENU</span>
          </button>
        )}

        {/* </div> */}

        <div className="hidden lg:flex">
          {!admin &&
            pages?.map((page, index) => (
              <div
                key={page?.name}
                className="inline-block"
                onMouseEnter={(e) => handleMenuOpen(e, page)}
                onMouseLeave={handleMenuClose}
              >
                <button
                  className={`${
                    landing ? "text-white" : "text-black"
                  } hover:text-[#C73336] px-4 py-2 font-[500]`}
                  onClick={() =>
                    page?.name == "Users" ? navigate("/admin-layout/users") : ""
                  }
                >
                  {page?.name}{" "}
                  {index === 3 || index === 4 ? null : <span>&#9662;</span>}
                </button>
                {anchorEl === page?.name && (
                  <div
                    className="absolute bg-white shadow-md mt-0 z-[999]"
                    onMouseEnter={(e) => handleMenuOpen(e, page)}
                    onMouseLeave={handleMenuClose}
                  >
                    <div className="w-[100%] flex px-0 py-6">
                      <div className="w-[280px] border-r border-gray-300 px-6 overflow overflow-y-auto h-[500px]">
                        <p className="font-semibold text-lg mb-4">
                          Browse by Brand
                        </p>
                        {carBrands &&
                          carBrands?.slice(0, 9)?.map((brand, index) => (
                            <div
                              onClick={() =>
                                navigate("/car-listing", {
                                  state: {
                                    maker_id: brand?.id,
                                    category_id: page?.category_id,
                                    name: brand?.car_maker,
                                  },
                                })
                              }
                              key={index}
                              className="flex justify-between mb-[21px] cursor-pointer hover:text-[#C73336] "
                            >
                              <p className="uppercase">
                                {brand?.car_maker} ({brand?.post_count})
                              </p>
                              <img
                                src={`${baseUrl}logos/${brand?.logo}`}
                                alt={brand?.car_maker}
                                width="30px"
                              />
                            </div>
                          ))}
                        {/* <p
                          onClick={() =>
                            navigate("/brand-category", {
                              state: {
                                category_id: page?.category_id,
                              },
                            })
                          }
                          className="font-semibold flex justify-between items-center hover:text-[#C73336] cursor-pointer"
                        >
                          EXPLORE MORE
                          <EastIcon />
                        </p> */}
                      </div>
                      <div className="w-[280px] border-r border-gray-300 px-6 overflow overflow-y-auto h-[500px]">
                        <p className="font-semibold text-lg mb-4">
                          Popular Models
                        </p>
                        {carModels?.slice(0, 9)?.map((model, index) => (
                          <p
                            onClick={() =>
                              navigate("/single-brand-category", {
                                state: {
                                  model_id: model?.id,
                                  category_id: page?.category_id,
                                  modelName: model?.model_name,
                                },
                              })
                            }
                            key={index}
                            className="mb-[21px] cursor-pointer hover:text-[#C73336] uppercase"
                          >
                            {model?.model_name}
                          </p>
                        ))}
                        {/* <p
                          onClick={() =>
                            navigate("/brand-category", {
                              state: {
                                category_id: page?.category_id,
                              },
                            })
                          }
                          className="font-semibold flex justify-between items-center hover:text-[#C73336] cursor-pointer"
                        >
                          EXPLORE MORE
                          <EastIcon />
                        </p> */}
                      </div>
                      <div className="w-[280px] px-6 overflow overflow-y-auto h-[500px]">
                        <p className="font-semibold text-lg mb-4">Cities</p>
                        {cities &&
                          cities?.slice(0, 9)?.map((city, index) => (
                            <p
                              onClick={() =>
                                navigate("/single-brand-category", {
                                  state: {
                                    city_id: city?.id,
                                    category_id: page?.category_id,
                                  },
                                })
                              }
                              key={index}
                              className="mb-[21px] cursor-pointer hover:text-[#C73336] uppercase"
                            >
                              {city?.name} ({city?.post_count})
                            </p>
                          ))}
                        {/* <p
                          onClick={() =>
                            navigate("/brand-category", {
                              state: {
                                category_id: page?.category_id,
                              },
                            })
                          }
                          className="font-semibold flex justify-between items-center hover:text-[#C73336] cursor-pointer"
                        >
                          EXPLORE MORE
                          <EastIcon />
                        </p> */}
                      </div>
                    </div>
                  </div>
                )}
                {anchorE2 === page?.name && (
                  <div
                    className="absolute bg-white shadow-md p-4 mt-0 z-[999] rounded rounded-2 w-[200px]"
                    onMouseEnter={(e) => handleMenuOpen(e, page)}
                    onMouseLeave={handleMenuClose}
                  >
                    {pages2?.map((item) => (
                      <div
                        key={index}
                        className="flex items-center gap-2 mb-2 cursor-pointer hover:text-[#C73336] "
                        onClick={() => navigate(`/${item?.path}`)}
                      >
                        {item?.icon}
                        <p className="">{item?.name}</p>
                      </div>
                    ))}
                  </div>
                )}
                {anchorE3 === page?.name && (
                  <div
                    className="absolute bg-white shadow-md p-4 mt-0 z-[999] rounded rounded-2 w-[200px]"
                    onMouseEnter={(e) => handleMenuOpen(e, page)}
                    onMouseLeave={handleMenuClose}
                  >
                    {bikes?.map((item) => (
                      <div
                        key={index}
                        className="flex items-center gap-2 mb-2 cursor-pointer hover:text-[#C73336] "
                        onClick={() => navigate(`/${item?.path}`)}
                      >
                        {item?.icon}
                        <p className="">{item?.name}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
        </div>
        {/* <div className="flex md:hidden">
          <CustomSearch />
        </div> */}
        <div className="flex lg:hidden">
          {!token || !user_id ? (
            <CustomButton
              onClick={() => navigate("/login")}
              style={{
                background: green,
                borderColor: green,
                padding: "0px 10px",
                fontWeight: 500,
                width: "100px",
                color:customWhite
              }}
              small="true"
            >
              <HiOutlineUserCircle style={{ fontSize: "22px" }} /> LOG IN
            </CustomButton>
          ) : (
            <div>
              <Dropdown
                menu={{
                  items,
                }}
                trigger={["click"]}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <Avatar className="bg-customGreen " icon={<UserOutlined />} />
                </div>
              </Dropdown>
            </div>
          )}
        </div>
        <div className="hidden lg:flex items-center gap-4">
          {!admin && (
            <CustomDropdown
              style={{
                background: "transparent",
                color: landing ? "white" : "black",
                boxShadow: "none",
              }}
              items={items2}
            >
              <div
                // onClick={() => setOpenModal(true)}
                // style={{
                //   background: "transparent",
                //   color: landing ? "white" : "black",
                //   boxShadow: "none",
                // }}
                className={`flex items-center gap-2 cursor-pointer ${
                  landing ? "text-white" : "[black]"
                } hover:text-[#C73336]`}
              >
                <MdOutlineSell className="mr-2 text-[18px] text-[#C73336]" />
                SELL WITH US
              </div>
            </CustomDropdown>
          )}
          {/* <div className="flex items-center gap-2"> */}
          {/* <PhoneInTalkIcon style={{ color: landing ? "white" : "" }} /> */}
          <div className="border-l border-gray-300 pl-4 text-base">
            {token || user_id || userData?.email_verified ===true? (
              <>
              <div>
                <Dropdown
                  menu={{
                    items,
                  }}
                  trigger={["click"]}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    {userData?.picture?
                  <img
                  className={landing? "":`border border-1 border-gray-300 hover hover:shadow-lg transition-shadow duration-300`}
                  src={userData?.picture}
                  alt="Profile"
                  onError={(e) => {
                    e.target.onerror = null; // Prevent infinite loop
                    e.target.src = "https://via.placeholder.com/100"; // Default image
                  }}
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "100%",
                    objectFit: "cover",
                  }}
                />
                 
                    :
                    <Avatar
                      className="bg-[#C73336] hover hover:bg-[#C73336] cursor-pointer"
                      icon={<UserOutlined />}
                    />
                    }
                    <div
                      className="mobile_none"
                      style={{
                        lineHeight: "100px",
                        color: landing ? "white" : "black",
                      }}
                    >
                      <p
                        style={{
                          lineHeight: "14px",
                        }}
                      >
                        {/* {loginData?.user_info?.name} */}
                        Welcome!
                      </p>
                      <p
                        style={{
                          lineHeight: "20px",
                          fontSize: "16px",
                          fontWeight: 600,
                        }}
                      >
                        {/* Shah Masood */}
                        {login_data?.user?.name || userData?.name}
                      </p>
                    </div>
                  </div>
                </Dropdown>
              </div>
            </>
            ) : (
              <div
              style={{ display: "flex", alignItems: "center", gap: "10px" }}
            >
              <CustomButton
                onClick={() => navigate("/login")}
                style={{
                  background: green,
                  borderColor: green,
                  padding: "20px 20px",
                  fontWeight: 500,
                  color:customWhite
                }}
              >
                <HiOutlineUserCircle style={{ fontSize: "22px" }} /> LOG IN
              </CustomButton>
            </div>
             
            )}
          </div>
          {/* </div> */}
        </div>
      </div>
    </>
  );
}
